import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

  showMenu = '';
  showSubMenu = '';


  public sidebarnavItems: RouteInfo[] = [];
  public sidebarnavItems_v2: RouteInfo[] = [];

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }

  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  constructor(private router: Router,
    private route: ActivatedRoute) {

    const location = [];
    const myurl = [];

    for (let i = 0; i < ROUTES.length; i++) {
      if (ROUTES[i].submenu.length > 0) {
        location.push(ROUTES[i].title);
        myurl.push(ROUTES[i].url);
      }
    }

    // for (let i = 0; i < ROUTES.length; i++) {
    //   if (this.router.url.includes(myurl[i])) {
    //     this.addExpandClass(location[i]);
    //   }
    // }

  }

  // End open close
  ngOnInit() {
    this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
  }


  private checkModuloID(modulos: any, codmod: number): boolean {
    let vResponse: boolean = false;

    if (modulos != null)
      modulos.forEach((element: any) => {
        if (element.codmod == codmod) {


          vResponse = true;
          return;
        }
      });
    return vResponse;

  }

}
